export default __webpack_public_path__ + "static/media/wave.b1a9e8c5.svg";